import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from "backbone";
import moment from 'moment';
import '../../MatchCentreLanding/index.styl';

export class MatchCentreInfoBar extends View {
	get template() {
		return template;
	}

	get className() {
		return 'info-bar';
	}

	initialize() {
		this.model = new Model({
			inited: false,
			image_squads_path: process.env.SQUAD_LOGOS_PATH,

		});
	}

	init({ selected_match, prev_match, next_match }) {
		const is_live = selected_match.status === 'playing';
		let time = null;

		if (is_live && selected_match.clock && selected_match.clock.s !== -1) {
			time = selected_match.clock.p + ' | ' + this.getReadableDate(selected_match.clock.s);
		}
		const link = '/match-centre/';
		const prev_link = prev_match ? `${link}${prev_match.round}/${prev_match.id}` : false;
		const next_link = next_match ? `${link}${next_match.round}/${next_match.id}` : false;
		this.model.set({
			inited: true,
			game_date: moment(selected_match.date).format('h:mma'),
			is_scheduled: selected_match.status === 'scheduled',
			is_completed: selected_match.status === 'complete',
			is_live: selected_match.status === 'playing',
			time,
			prev_link,
			next_link,
			...selected_match
		});

		this.render();
	}

	getReadableDate(seconds = 0) {
		let min = parseInt(seconds / 60, 10),
			sec = seconds - min * 60;
		if (min < 10) {
			min = '0' + min;
		}
		if (sec < 10) {
			sec = '0' + sec;
		}

		return min + ':' + sec;
	}

}

export default MatchCentreInfoBar;